import I18n from 'i18n-js';
import { oneOf } from 'prop-types';

import { useRadarConfig } from '@lootboy/lib/slices/radarConfig';

import LoadingWrapper from '~/components/LoadingWrapper';
import Markdown from '~/components/Markdown';
import PopupMinimalistic from '~/components/PopupMinimalistic';

import styles from './RadarLegalTextPopupTemplate.module.scss';

export default function RadarLegalTextPopupTemplate({ property }) {
  const {
    config: { legalText = {} },
    loading,
  } = useRadarConfig();

  return (
    <PopupMinimalistic
      className={styles.guidelinesPopup}
      containerClassName={styles.guidelinesPopupContainer}
    >
      <div className={styles.guidelinesHeaderWrapper}>
        <h1 className={styles.guidelinesHeader}>
          {I18n.t(`RadarView_${property}_headline`)}
        </h1>
      </div>
      <LoadingWrapper loading={loading || !legalText[property]}>
        <Markdown className={styles.guidelines}>{legalText[property]}</Markdown>
      </LoadingWrapper>
    </PopupMinimalistic>
  );
}

RadarLegalTextPopupTemplate.propTypes = {
  property: oneOf(['terms', 'privacy']),
};
